import React from 'react';
import { Group, Stack, Text, Box } from '@mantine/core';
import { Home, Building2, CreditCard, Headphones, MoreHorizontal } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
type NavItem = 'home' | 'properties' | 'payments' | 'support' | 'more';
interface BottomNavProps {
  active: NavItem;
  onNavigate: (item: NavItem) => void;
}
export function BottomNav({
  active,
  onNavigate
}: BottomNavProps) {
  const {
    t,
    isRTL
  } = useLanguage();
  const navItems: {
    id: NavItem;
    labelKey: string;
    icon: typeof Home;
  }[] = [{
    id: 'home',
    labelKey: 'navigation.home',
    icon: Home
  }, {
    id: 'properties',
    labelKey: 'navigation.properties',
    icon: Building2
  }, {
    id: 'payments',
    labelKey: 'navigation.payments',
    icon: CreditCard
  }, {
    id: 'support',
    labelKey: 'navigation.support',
    icon: Headphones
  }, {
    id: 'more',
    labelKey: 'navigation.more',
    icon: MoreHorizontal
  }];
  return <Box style={{
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e2e8f0',
    paddingBottom: 'env(safe-area-inset-bottom)',
    zIndex: 100
  }} data-id="element-31">
      <Group justify="space-around" align="center" h={64} px="xs" style={{
      flexDirection: isRTL ? 'row-reverse' : 'row'
    }} data-id="element-32">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = active === item.id;
        return <Box key={item.id} onClick={() => onNavigate(item.id)} style={{
          cursor: 'pointer',
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          transition: 'all 0.2s ease'
        }} role="button" tabIndex={0} aria-label={t(item.labelKey)} aria-current={isActive ? 'page' : undefined} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            onNavigate(item.id);
          }
        }} data-id="element-33">
              <Stack gap={4} align="center" data-id="element-34">
                <Box p={6} style={{
              backgroundColor: isActive ? '#d1fae5' : 'transparent',
              borderRadius: 12,
              transition: 'all 0.2s ease'
            }} onMouseEnter={e => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = '#f1f5f9';
              }
            }} onMouseLeave={e => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-35">
                  <Icon size={22} color={isActive ? '#10b981' : '#64748b'} strokeWidth={isActive ? 2.5 : 2} data-id="element-36" />
                </Box>
                <Text size="xs" fw={isActive ? 600 : 500} c={isActive ? '#10b981' : '#64748b'} data-id="element-37">
                  {t(item.labelKey)}
                </Text>
              </Stack>
            </Box>;
      })}
      </Group>
    </Box>;
}